module.exports = __webpack_public_path__ + "static/media/AATZ.def774e5.PNG";